import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,

    zIndex: 100,
  },
  nested: {
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    minWidth: theme.spacing(4),
  },
  padding: {
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    paddingRight: 0,
  },
  icon: {
    minWidth: theme.spacing(4),
  },
  listSelected: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  listIconSelected: {
    color: "white",
  },
}));
export default useStyles;
